import { useRouter } from 'next/router';
import { QuizLogo } from '@/components';
import { trackGnbAnalytics } from '@/layout/Header';
export const HomeLogo = ({
  location,
  isSmall,
  showFullLogoFromTabletSm,
  redirectUrl = '/landing',
  className
}: {
  location: 'header' | 'play';
  isSmall?: boolean;
  showFullLogoFromTabletSm?: boolean;
  redirectUrl?: string;
  className?: string;
}) => {
  const router = useRouter();
  const goHome = () => {
    trackGnbAnalytics('home', location);
    void router.push(redirectUrl);
  };
  if (isSmall) {
    return <img className={'size-[24px] cursor-pointer'} onClick={goHome} src="/assets/logo_small_q.svg" alt="" />;
  }
  return <QuizLogo className={className} showFullLogoFromTabletSm={showFullLogoFromTabletSm} onClick={goHome} data-sentry-element="QuizLogo" data-sentry-component="HomeLogo" data-sentry-source-file="HomeLogo.tsx" />;
};